import { CAP_HISTORICAL_NOTICES_ACTION_TYPES } from '@constants/actionTypes/capHistoricalNoticesActionTypes';
import { PAGE_SIZE } from '@constants/common.constants';
import {
    HISTORICAL_NOTICES_DEFAULT_SORT_COLUMN,
    HISTORICAL_NOTICES_DEFAULT_SORT_ORDER,
    HISTORICAL_NOTICES_INITIAL_PAGE_NUMBER,
} from '@modules/historical-notices/constants';
import type { ICapHistoricalNoticesListState } from '@modules/historical-notices/cap/cap.types';

export const INITIAL_STATE: ICapHistoricalNoticesListState = {
    hasLoaded: false,
    notices: [],
    totalCount: 0,
    pageNumber: HISTORICAL_NOTICES_INITIAL_PAGE_NUMBER,
    pageSize: PAGE_SIZE,
    totalPages: 0,
    sortColumn: HISTORICAL_NOTICES_DEFAULT_SORT_COLUMN,
    sortOrder: HISTORICAL_NOTICES_DEFAULT_SORT_ORDER,
    hasLoadError: false,
};

function capHistoricalNoticesReducer(
    state = INITIAL_STATE,
    action: { type?: string; payload?: ICapHistoricalNoticesListState } = {},
) {
    switch (action.type) {
        case CAP_HISTORICAL_NOTICES_ACTION_TYPES.SET_CAP_HISTORICAL_NOTICES: {
            if (!action.payload) {
                return state;
            }

            return { ...state, ...action.payload };
        }
        case CAP_HISTORICAL_NOTICES_ACTION_TYPES.RESET_CAP_HISTORICAL_NOTICES:
            return INITIAL_STATE;
        default:
            return state;
    }
}

export default capHistoricalNoticesReducer;
